export default function arRows(el) {
  for (let x = 0; x < el.length; ++x) {
    let element = el[x];
    let row = element.querySelectorAll(".row");
    for (let r = 0; r < row.length; ++r) {
      justifyRows(row[r], element);
    }
  }
}

// Justified, row-based grid:
// ====================================
function justifyRows(row, container) {
  let rowsMargin = container.getAttribute("data-margin"),
    img = row.querySelectorAll("img.photo"),
    cell = row.querySelectorAll(".cell"),
    fh = 0,
    total = 0,
    imgCount = 0,
    num = img.length,
    deductMargin = rowsMargin * (num - 1),
    containerWidth = container.offsetWidth - deductMargin;

  if (img.length) {
    fh = row.querySelector("img.photo").getAttribute("data-height");
  }

  // step 1: collect aspect ratios, set new aspect ratios based on a uniform height (we'll use the first image as our baseline)
  for (let i = 0; i < num; ++i) {
    var _this = img[i],
      ow = _this.getAttribute("data-width"), // "original" width
      oh = _this.getAttribute("data-height"), // "original" height
      r = oh / ow, // aspect ratio 1.33
      wh = fh, // new "working" height (data-height attr of first image)
      ww = wh / r; // new "working" width

    // set new width, height, and ratio attributes, based on our "working" height
    _this.setAttribute("data-width", ww);
    _this.setAttribute("data-height", wh);
    _this.setAttribute("data-ratio", r);

    // add new width to our "total width" number.
    total += ww;

    imgCount++;

    if (imgCount == num) {
      setImageDimensions(total);
    }
  }

  function setImageDimensions(total) {
    for (let i = 0; i < num; ++i) {
      let _this = img[i],
        ww = _this.getAttribute("data-width"),
        r = _this.getAttribute("data-ratio"),
        wh = _this.getAttribute("data-height");

      // image's width percentage (of "total"), in decimal format:
      let percentage = ww / total;

      // image's width percentage, relative to the container's width:
      let relativeWidth = percentage * containerWidth,
        // set image's height, based on its aspect ratio:
        // newHeight = adjustedPercentage * r,
        newHeight = relativeWidth * r,
        // set a consistent height ratio value, relative to the container's width:
        heightRatio = newHeight / containerWidth;

      // set some things on the CELL level, so we can access them on resize
      let imgCell = _this.parentNode;
      imgCell.style.marginBottom = rowsMargin + "px";
      imgCell.style.width = containerWidth * percentage + "px";
      imgCell.setAttribute("data-ratio", r);
      imgCell.setAttribute("data-percW", percentage);
      imgCell.setAttribute("data-percH", heightRatio);
      imgCell.setAttribute("data-numImages", num);

      // set height of the image:
      _this.style.height = newHeight + "px";
    }
  }
} // end justifyRows()
